import {Button as JoyButton, ButtonProps, useTheme} from "@mui/joy"


const Button = (props: ButtonProps) => {
    const theme = useTheme()
    return <JoyButton sx={{
        background: `linear-gradient(45deg, ${theme.palette.primary[700]}, #2DDF82)`,
        color:"primary.100",
        borderRadius:"15px",
        ...props.sx
    }} {...props}>
        {props.children}
    </JoyButton>
}

export default Button